import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";

/** A saved hotel, riad or villa as /account draws it. */
export type SavedStay = {
  id: string;
  slug: string;
  name: string;
  citySlug: string;
  cityName?: string | null;
  image?: string | null;
  propertyType?: string | null;
  starRating?: number | null;
};

/** /me/saved/stays: the account's saved stays, apart from saved activities. */
export const savedStaysApi = {
  listMine: async (lang?: string): Promise<SavedStay[]> => {
    const res = unwrap(await api.me.saved.stays.get({ query: lang ? { lang } : {} }));
    return (res?.items ?? []) as SavedStay[];
  },
  add: async (id: string) => {
    unwrap(await api.me.saved.stays.post({ stay_id: id }));
  },
  remove: async (id: string) => {
    unwrap(await api.me.saved.stays({ id }).delete());
  },
  sync: async (ids: string[]) => {
    unwrap(await api.me.saved.stays.sync.post({ ids }));
  },
};
